import { Provider } from "@angular/core";
import { Observable } from "rxjs";
import { UseCase } from "../../../core/use-case";
import { Resource } from "../../models/personnel.model";
import { ProjectEvaluationRepository } from "../../repositories/project-evaluation.repository";

interface SearchResourcesUseCaseParams {
  search?: string;
}

export class SearchResourcesUseCase
  implements UseCase<SearchResourcesUseCaseParams, Resource[]>
{
  constructor(private repo: ProjectEvaluationRepository) {}
  
  execute(param: SearchResourcesUseCaseParams): Observable<Resource[]> {
    return this.repo.searchResources(param.search);
  }
}

const searchResourcesUseCaseFactory = (repo: ProjectEvaluationRepository) =>
  new SearchResourcesUseCase(repo);

export const searchResourcesUseCaseProvider: Provider = {
  provide: SearchResourcesUseCase,
  useFactory: searchResourcesUseCaseFactory,
  deps: [ProjectEvaluationRepository],
};
